import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryWhatsApp() {
    const requestListagem = useRequestListagem();

    return useQuery<string>({
        queryKey: ['whatsapp'],
        queryFn: () =>
            requestListagem({
                url: '/config/configgeral/chave',
                extraParams: [{ dsChave: 'URL_WHATSAPP' }],
            }).then((res) => res.data),
        enabled: true,
    });
}
